import { Api } from "../axios-config";

export interface IContact {
    _id?: string;
    ClientName: string;
    Assunto: string;
    WhatsApp: string;
    Descricao: string;
}

const createContact = async (contact: IContact): Promise<IContact | Error> => {
    try {
        const { data } = await Api.post("/contacts", contact);
        if (data) {
            return data;
        } else {
            return new Error('Erro ao enviar contato');
        }
    } catch (error) {
        return new Error(`Erro ao enviar contato: ${error}`);
    }
};

export const ContactServices = {
    createContact,
};
